module.exports = __webpack_public_path__ + "media/images/fonts/HKGroteskPro/HKGroteskPro-HairlineItalic-852453f001d453bf63c9497902fab002.otf";